import { DateTime } from 'luxon'

// min and max arguments must be strings in valid ISO 8601 format
// e.g. 2016-05-25T09:24 or 2016-05-25T09:24:15

const matchFilterBetweenDateTimes = (
  value: string,
  min?: string,
  max?: string,
) => {
  const valueDateTime = DateTime.fromFormat(value, 'dd/MM/yyyy hh:mm', { zone: 'utc' })
  const minDateTime = min ? DateTime.fromISO(min, { zone: 'utc' }) : null
  const maxDateTime = max ? DateTime.fromISO(max, { zone: 'utc' }) : null

  if (!min && !max) return true
  if (!value) return false

  if (minDateTime && !maxDateTime) return valueDateTime >= minDateTime
  if (!minDateTime && maxDateTime) return valueDateTime <= maxDateTime

  if (minDateTime !== null && maxDateTime !== null){
    return valueDateTime >= minDateTime && valueDateTime <= maxDateTime
  }

  return false
}

export default matchFilterBetweenDateTimes
